export const RouteTypes = {
  Unprotected: 0,
  RoleProtected: 1,
  ClientRoleProtected: 2,
  RightProtected: 3,
  ClientRightProtected: 4,
  ClientRightsProtected: 5,
  ClientCrmRightsProtected: 6,
  ClientCrmAccessRightsProtected: 7,
};
